module.exports = __webpack_public_path__ + "media/images/appTitle-042bd4b282d6094068dbe02d58605c4f.png";